export default {"src":"/_next/static/media/metaMask.48b377dc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};